var FooterFactory = function ($resource, $window) {
    var siteContactInfoParams = {
        gaId: "@gaId"
    };

    return $resource(
        __baseApiUrl__ + "/participant-web-services/rest/sitecontactinfo/:gaId",
        siteContactInfoParams,
        {
            query: {
                method: "GET",
                isArray: false
            }
        }
    );
};

FooterFactory.$inject = ["$resource", "$window"];
export default FooterFactory;
